export const spotManifest = (environment) => ({
    short_name: process.env.REACT_APP_MANIFEST_SPOT_NAME || '',
    name: process.env.REACT_APP_MANIFEST_SPOT_NAME || '',
    icons: [
        {
            src: environment === 'demo' ? 'manifest-gcex-demo.jpg' : 'manifest-gcex.jpg',
            sizes: '512x512 192x192 64x64 32x32 24x24 16x16',
            type: 'image/x-icon',
            purpose: 'any maskable'
        }
    ],
    start_url: '.',
    display: 'standalone',
    theme_color: '#000000',
    background_color: '#ffffff'
});

export const traderManifest = (environment) => ({
    short_name: process.env.REACT_APP_MANIFEST_TRADER_NAME || '',
    name: process.env.REACT_APP_MANIFEST_TRADER_NAME || '',
    icons: [
        {
            src: environment === 'demo' ? 'manifest-gcex-demo.jpg' : 'manifest-gcex.jpg',
            sizes: '512x512 192x192 64x64 32x32 24x24 16x16',
            type: 'image/x-icon',
            purpose: 'any maskable'
        }
    ],
    start_url: '.',
    display: 'standalone',
    theme_color: '#000000',
    background_color: '#ffffff'
});

export const digitalManifest = (environment) => ({
    short_name: process.env.REACT_APP_MANIFEST_DIGITAL_NAME || '',
    name: process.env.REACT_APP_MANIFEST_DIGITAL_NAME || '',
    icons: [
        {
            src: environment === 'demo' ? 'manifest-gcex-demo.jpg' : 'manifest-gcex.jpg',
            sizes: '512x512 192x192 64x64 32x32 24x24 16x16',
            type: 'image/x-icon',
            purpose: 'any maskable'
        }
    ],
    start_url: '.',
    display: 'standalone',
    theme_color: '#000000',
    background_color: '#ffffff'
});

export const portalManifest = (environment) => ({
    short_name: 'GCEX XplorPortal',
    name: 'GCEX XplorPortal',
    icons: [
        {
            src: environment === 'demo' ? 'manifest-gcex-demo.jpg' : 'manifest-gcex.jpg',
            sizes: '512x512 192x192 64x64 32x32 24x24 16x16',
            type: 'image/x-icon',
            purpose: 'any maskable'
        }
    ],
    start_url: '.',
    display: 'standalone',
    theme_color: '#000000',
    background_color: '#ffffff'
});
